




















































































import { Component, Inject, Vue, Watch } from 'vue-property-decorator'
import { CompanyAPI } from '@/api/backend-client'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import App, { KVConfiguration } from '@/embed/widget/App.vue'

/** added the components because the autoloader does not understand App */
@Component({
    components: {
        App,
    },
})
export default class EmmaWidget extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    company: Company = null
    loading: boolean = false
    saving: boolean = false
    showEmbedCode: boolean = false
    showPreview: boolean = false

    async created() {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.company = cloneDeep<Company>(this.$currentCompany)
        this.loading = false
    }

    async save(): Promise<void> {
        try {
            this.loading = true
            this.$root.$currentCompany = await CompanyAPI.updateWidgetSettings(this.company.id, this.company)

            await this.reload()
        } finally {
            this.loading = false
        }
    }

    @Watch('company.widgetEnabled')
    switchPreview() {
        if (this.company.widgetEnabled === false) {
            this.showPreview = false
        }
    }

    get widgetConfiguration(): KVConfiguration {
        return {
            companyId: this.company.id,
            companyName: '',
            enabled: this.company.widgetEnabled,
            avatarStyle: this.company.widgetAvatarStyle,
            avatarBackground: this.company.widgetAvatarCircle,
            type: this.company.widgetType,
            flows: this.company.activatedWidgetFlowTypes,
            avatar: {
                goals: this.company.widgetGoals,
                menuColor: this.company.widgetAvatarBackgroundColor,
                menuTextColor: this.company.widgetAvatarTextColor,
            },
            popup: {
                style: this.company.widgetPopupType,
                flow: this.company.widgetPopupFlowType,
                position: this.company.widgetPopupPosition,
                animation: this.company.widgetPopupAnimation,
                animationPopupTime: this.company.widgetPopupOpenTime,
                backgroundColor: this.company.widgetPopupBackgroundColor,
                textColor: this.company.widgetPopupTextColor,
                buttonBackgroundColor: this.company.widgetPopupButtonColor,
                buttonTextColor: this.company.widgetPopupButtonTextColor,
                font: this.company.widgetPopupFont,
                contents: this.company.widgetPopupContents,
            },
            tag: '',
        }
    }

    get widgetUrl(): string {
        return [
            '<script src="',
            process.env.VUE_APP_KEYVUE_FRONTEND_BASEURL,
            '/embed/widget.js?company=',
            this.company.id,
            '"><\/script>',
        ].join('')
    }
}
